import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const EyeOpen = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      stroke={iconColor}
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="2"
    >
      <title>{iconTitle}</title>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
};

EyeOpen.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

EyeOpen.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(EyeOpen);
